<script lang="ts" setup>
import type { ProductListResponseItem } from 'types/index';

defineProps<{
  products: ProductListResponseItem[];
  loading: boolean;
}>();
</script>

<template>
  <BaseList
    transition-name="product-list"
    :loading="loading"
    class="grid gap-8 sm:grid-cols-2 lg:grid-cols-3"
    :aria-label="$t('Aria.ProductListPage.ProductList')"
  >
    <li
      v-for="(product, i) in products"
      :key="`${product.title}-${i}`"
    >
      <PartialsProductListItem :product-item="product" />
    </li>
  </BaseList>
</template>
